export enum JobPostingSteps {
  STEP_1 = 'company-job',
  STEP_2 = 'skills',
  STEP_3 = 'category-budget',
  STEP_4 = 'attach-file',
  STEP_5 = 'review',
}
